import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import ProfileNotesSection from '/component/partial/profile/ProfileNotesSection';
import {withTranslation} from '/provider/TranslationProvider';
import {updateCandidateNotes} from '/redux/action/candidate.action';
import {
  notesById,
  notesUpdatedTsById,
  statusById,
} from '/redux/selector/candidate.selector';
import {withHOC} from '/util/hoc.util';

export default withHOC(
  connect(
    createStructuredSelector({
      notes: notesById,
      notesUpdatedTs: notesUpdatedTsById,
      status: statusById,
    }),
    dispatch => ({
      updateCandidateNotes: ({candidateId, body}: any) =>
        // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
        dispatch(updateCandidateNotes({candidateId, body})),
    }),
    (stateProps, dispatchProps, ownProps: any) => ({
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      onSave: (notes: string) => {
        return dispatchProps.updateCandidateNotes({
          candidateId: ownProps.candidateId,
          body: {notes},
        });
      },
    }),
  ),
  withTranslation('screen.candidateProfile.section.notes'),
)(ProfileNotesSection);
